import React, { useState } from "react";
import { useLoader } from "../../../context/LoaderContext";
import axios from "axios";
import { headers } from "../../../exports/exports";
import { dynamicFailed, dynamicSuccess } from "../../../hooks/useToast";
import { sendErrorLog } from "../../ErrorLog";

interface PersonalInformationProps {
  firstname: string;
  setFirstname: React.Dispatch<React.SetStateAction<string>>;

  middlename: string;
  setMiddlename: React.Dispatch<React.SetStateAction<string>>;

  lastname: string;
  setLastname: React.Dispatch<React.SetStateAction<string>>;

  age: number | null;
  setAge: React.Dispatch<React.SetStateAction<number | null>>;

  sex: string;
  setSex: React.Dispatch<React.SetStateAction<string>>;

  designation: string;
  setDesignation: React.Dispatch<React.SetStateAction<string>>;

  qualifications: string;
  setQualifications: React.Dispatch<React.SetStateAction<string>>;

  professionalAffiliations: string;
  setProfessionalAffiliations: React.Dispatch<React.SetStateAction<string>>;

  memberId: number;
}

const PersonalInformation: React.FC<PersonalInformationProps> = ({
  firstname,
  setFirstname,
  middlename,
  setMiddlename,
  lastname,
  setLastname,
  age,
  setAge,
  sex,
  setSex,
  designation,
  setDesignation,
  qualifications,
  setQualifications,
  professionalAffiliations,
  setProfessionalAffiliations,
  memberId,
}) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { setLoading } = useLoader();

  const validateStep = () => {
    let newErrors: { [key: string]: string } = {};
    if (!firstname) newErrors.firstname = "First Name is required";
    if (!lastname) newErrors.lastname = "Last Name is required";

    if (!age) newErrors.age = "Age is required";
    if (!sex) newErrors.sex = "Please select a gender";

    if (!designation) newErrors.designation = "Designation is required";
    if (!qualifications)
      newErrors.qualifications = "Qualifications are required";
    if (!professionalAffiliations)
      newErrors.professionalAffiliations =
        "Professional Affiliations are required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    try {
      const data = {
        data: {
          First_Name: firstname,
          Middle_Name: middlename,
          Last_Name: lastname,
          Age: age,
          Sex: sex,
          Designation: designation,
          Qualifications: qualifications,
          Professional_Affiliations: professionalAffiliations,
        },
      };
      axios
        .put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberId}`,
          data,
          {
            headers: headers,
          },
        )
        .then(() => {
          dynamicSuccess("Profile updated successfully!");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(async (e: any) => {
          await sendErrorLog(
            "User Update Error",
            `${firstname} ${lastname}`,
            "",
            "",
            e?.config?.url,
            e.message,
          );
          dynamicFailed(`${e.message}`);
          setLoading(false);
        });
    } catch (e: any) {
      await sendErrorLog(
        "User Update Error",
        `${firstname} ${lastname}`,
        "",
        "",
        e?.config?.url,
        e.message,
      );
      dynamicFailed(`${e.message}`);
      setLoading(false);
    }
  };
  return (
    <>
      <div className="user-card__header">
        <div className="user-card__info" style={{ marginLeft: "unset" }}>
          <h3>Personal Information</h3>
          <p className="user-card__designation">
            Update your personal informaiton
          </p>
        </div>
      </div>
      <hr />
      <div className="col-xl-4">
        <div className="become-volunteer__input">
          <input
            type="text"
            placeholder="First Name*"
            name="firstname"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            className={errors.firstname && "error-border"}
          />
          {errors.firstname && (
            <p className="error-message">{errors.firstname}</p>
          )}
        </div>
      </div>
      <div className="col-xl-4">
        <div className="become-volunteer__input">
          <input
            type="text"
            placeholder="Middle Name"
            name="middlename"
            value={middlename}
            onChange={(e) => setMiddlename(e.target.value)}
          />
        </div>
      </div>
      <div className="col-xl-4">
        <div className="become-volunteer__input">
          <input
            type="text"
            placeholder="Last Name*"
            name="lastname"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            className={errors.lastname && "error-border"}
          />
          {errors.lastname && (
            <p className="error-message">{errors.lastname}</p>
          )}
        </div>
      </div>
      <div className="col-xl-4">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="Age*"
            name="age"
            value={age || ""}
            onChange={(e) => setAge(Number(e.target.value))}
            className={errors.age && "error-border"}
          />
          {errors.age && <p className="error-message">{errors.age}</p>}
        </div>
      </div>
      <div className="col-xl-4">
        <div className="become-volunteer__input">
          <select
            name="Gender"
            className={`become-volunteer__select ${
              errors.sex && "error-border"
            }`}
            defaultValue=""
            value={sex}
            onChange={(e) => setSex(e.target.value)}
          >
            <option value="" disabled>
              Gender*
            </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
          {errors.sex && <p className="error-message">{errors.sex}</p>}
        </div>
      </div>
      <div className="col-xl-4">
        <div className="become-volunteer__input">
          <input
            type="text"
            placeholder="Designation*"
            name="designation"
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
            className={errors.designation && "error-border"}
          />
          {errors.designation && (
            <p className="error-message">{errors.designation}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input become-volunteer__message-box">
          <textarea
            name="qualifications"
            placeholder="Qualifications*"
            value={qualifications}
            onChange={(e) => setQualifications(e.target.value)}
            className={errors.qualifications && "error-border"}
          ></textarea>
          {errors.qualifications && (
            <p className="error-message">{errors.qualifications}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input become-volunteer__message-box">
          <textarea
            name="professionalaffiliations"
            placeholder="Professional Affiliations*"
            value={professionalAffiliations}
            onChange={(e) => setProfessionalAffiliations(e.target.value)}
            className={errors.professionalAffiliations && "error-border"}
          ></textarea>
          {errors.professionalAffiliations && (
            <p className="error-message">{errors.professionalAffiliations}</p>
          )}
        </div>
      </div>
      <div className="become-volunteer__btn-box" style={{ textAlign: "end" }}>
        <button
          type="submit"
          className="thm-btn become-volunteer__btn become-volunteer__submit"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default PersonalInformation;
